import styled from "styled-components";

export const Styled = styled.div`
  width: 100%;
  height: 100%;
  background: white;
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  .log-content {
    flex: 1;
    overflow-y: auto;
    min-height: 0;
    display: flex;
    flex-direction: column;

    > div {
      flex: 1;
      display: flex;
      flex-direction: column;
    }
  }

  .modal-header {
    height: 55px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 16px;
    border-bottom: 1px solid var(--color-gray-100, #e2e3e5);
    border-radius: 8px 8px 0 0;

    span,
    .breadcrumb .section {
      color: var(--color-gray-950, #19191b);
      font-size: var(--font-size-lg, 20px);
      font-weight: 900;
      line-height: var(--font-line-height-lg, 28px);
    }
  }
`;
